import { PortableText } from '@portabletext/react';
import React from 'react';

export const RichText = ({ content, className }) => (
  <div className={className}>
    <PortableText value={content} />
  </div>
);
